import React from "react";
import Button from "~/components/button";

type OverrideSyncButtonsProps = {
  loading: boolean;
  handle: (retrySync: boolean) => void;
};

export const OverrideSyncButtons: React.FC<OverrideSyncButtonsProps> = ({
  loading,
  handle,
}) => {
  return (
    <>
      <Button onClick={() => handle(false)} disabled={loading}>
        Override Sync Status
      </Button>
      <Button onClick={() => handle(true)} disabled={loading}>
        Retry Sync
      </Button>
    </>
  );
};
